import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["title", "onClick"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { style: {"margin-top":"-10px"} }
const _hoisted_5 = { style: {"color":"#409eff","text-decoration":"none"} }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"100% !important","background-color":"#409eff"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"14% !important","color":"#fff","text-align":"center"} }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " L/Φ(长度/直径)(cm) ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"14% !important","color":"#fff","text-align":"center"} }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " W/Φ(宽度/直径)(cm) ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"14% !important","color":"#fff","text-align":"center"} }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " H(高度)(cm) ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"14% !important","color":"#fff","text-align":"center"} }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " 体积(CBM) ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"14% !important","color":"#fff","text-align":"center"} }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " 净重(KGS) ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"14% !important","color":"#fff","text-align":"center"} }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " 毛重(KGS) ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"16% !important","color":"#fff","text-align":"center"} }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%"} }, "数量")
  ])
], -1)
const _hoisted_8 = { style: {"float":"left","width":"14% !important","text-align":"center"} }
const _hoisted_9 = { style: {"float":"left","width":"14% !important","text-align":"center"} }
const _hoisted_10 = { style: {"float":"left","width":"14% !important","text-align":"center"} }
const _hoisted_11 = { style: {"float":"left","width":"14% !important","text-align":"center"} }
const _hoisted_12 = { style: {"float":"left","width":"14% !important","text-align":"center"} }
const _hoisted_13 = { style: {"float":"left","width":"14% !important","text-align":"center"} }
const _hoisted_14 = { style: {"float":"left","width":"16% !important","text-align":"center"} }
const _hoisted_15 = { style: {"width":"100% !important","background-color":"#409eff"} }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"50% !important","color":"#fff","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " 规格型号名称 ")
], -1)
const _hoisted_17 = { style: {"float":"left","width":"50% !important","color":"#fff","text-align":"center"} }
const _hoisted_18 = { style: {"width":"100%"} }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { style: {"float":"left","width":"50% !important","text-align":"center"} }
const _hoisted_21 = { style: {"float":"left","width":"50% !important","text-align":"center"} }
const _hoisted_22 = {
  key: 1,
  style: {"height":"60px","line-height":"60px","border-bottom":"1px solid #efefef","text-align":"center"}
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "包装内的产品与数量", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"100% !important","background-color":"#409eff"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"25% !important","color":"#fff","text-align":"center"} }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " 产品名称 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"25% !important","color":"#fff","text-align":"center"} }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"border-right":"1px solid #efefef","width":"100%"} }, " 规格型号名称 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"25% !important","color":"#fff","text-align":"center"} }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%"} }, " 包装内的数量 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"25% !important","color":"#fff","text-align":"center"} }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%"} }, " 单位 ")
  ])
], -1)
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { style: {"float":"left","width":"25% !important","text-align":"center"} }
const _hoisted_27 = { style: {"float":"left","width":"25% !important","text-align":"center"} }
const _hoisted_28 = { style: {"float":"left","width":"25% !important","text-align":"center"} }
const _hoisted_29 = { style: {"float":"left","width":"25% !important","text-align":"center"} }
const _hoisted_30 = {
  key: 1,
  style: {"height":"60px","line-height":"60px","border-bottom":"1px solid #efefef","text-align":"center"}
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 包装的图片 ", -1)
const _hoisted_32 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_33 = { style: {"width":"100% !important"} }
const _hoisted_34 = { style: {"width":"100%","height":"100%","text-align":"center","background-color":"#fff"} }
const _hoisted_35 = ["href"]
const _hoisted_36 = ["src"]
const _hoisted_37 = { style: {"width":"100%","text-align":"center","font-weight":"900"} }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"20px"} }, null, -1)
const _hoisted_39 = { style: {"clear":"both"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_menu_tab = _resolveComponent("miezz-menu-tab")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_miezz_thumbnail = _resolveComponent("miezz-thumbnail")!
  const _component_miezz_form = _resolveComponent("miezz-form")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_miezz_menu_tab, {
      modelValue: _ctx.menuTab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.menuTab) = $event))
    }, null, 8, ["modelValue"]),
    (_openBlock(), _createBlock(_component_miezz_form, {
      modelValue: _ctx.detail,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.detail) = $event)),
      key: _ctx.random,
      fix: true
    }, {
      "form-item": _withCtx(({ item }) => [
        (item.Prop == 'ProductId' && _ctx.detail.Data.ProductId && _ctx.type=='10')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: item.Label
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.Data.ProductName), 1)
              ]),
              _: 2
            }, 1032, ["label"]))
          : _createCommentVNode("", true),
        (item.Prop == 'Code')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: item.Label
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.isString(_ctx.detail.Data.Code)), 1)
              ]),
              _: 2
            }, 1032, ["label"]))
          : _createCommentVNode("", true),
        (item.Prop == 'PackageZh')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 2,
              label: item.Label
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.isString(_ctx.detail.Data.PackageNameZh)), 1)
              ]),
              _: 2
            }, 1032, ["label"]))
          : _createCommentVNode("", true),
        (item.Prop == 'PackageEn')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 3,
              label: item.Label
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.isString(_ctx.detail.Data.PackageEn)), 1)
              ]),
              _: 2
            }, 1032, ["label"]))
          : _createCommentVNode("", true),
        (item.Prop == 'PackageImages')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 4,
              prop: item.Prop,
              label: item.Label
            }, {
              default: _withCtx(() => [
                (_ctx.detail.Data.PackageImages!=null && _ctx.detail.Data.PackageImages!=undefined && _ctx.detail.Data.PackageImages.length>0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.Data.PackageImages, (p, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          title: p.Name,
                          key: index,
                          style: {"height":"100px","width":"100px","overflow":"hidden","text-align":"center","margin-top":"-15px","float":"left","margin-right":"15px","cursor":"pointer"},
                          onClick: ($event: any) => (_ctx.onImage(p))
                        }, [
                          _createElementVNode("div", null, [
                            _createElementVNode("img", {
                              style: {"height":"60px"},
                              src: p.Url
                            }, null, 8, _hoisted_3)
                          ]),
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("span", _hoisted_5, _toDisplayString(p.Name), 1)
                          ])
                        ], 8, _hoisted_2))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, [
                      _createVNode(_component_miezz_thumbnail, {
                        modelValue: undefined,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((undefined) = $event)),
                        type: 'image',
                        icon: 'DocumentDelete'
                      })
                    ]))
              ]),
              _: 2
            }, 1032, ["prop", "label"]))
          : _createCommentVNode("", true),
        (item.Prop == 'PackageShapes')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 5,
              label: item.Label
            }, {
              label: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(item.Label), 1)
              ]),
              default: _withCtx(() => [
                _hoisted_7,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.Data.PackageShapes, (p, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    style: {"width":"100% !important","padding-top":"5px"},
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.isString(p.Length)) + "  ", 1),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.isString(p.Width)) + "  ", 1),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.isString(p.Height)) + "  ", 1),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.isString(p.Volume)) + "  ", 1),
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.isString(p.NetWeight)) + "  ", 1),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.isString(p.GrossWeight)) + "  ", 1),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.isString(p.Quantity)) + "  ", 1)
                  ]))
                }), 128))
              ]),
              _: 2
            }, 1032, ["label"]))
          : _createCommentVNode("", true),
        (item.Prop == 'PackageSpecs' && _ctx.type != '20')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 6,
              label: item.Label
            }, {
              label: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(item.Label), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createTextVNode(" 包装内的数量"),
                      _createElementVNode("span", null, "（" + _toDisplayString(_ctx.detail.Data.ChargeUnithZh) + "）", 1)
                    ])
                  ])
                ]),
                (_ctx.detail.Data.PackageSpecs !=null && _ctx.detail.Data.PackageSpecs !=undefined && _ctx.detail.Data.PackageSpecs.length>0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.Data.PackageSpecs, (p, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          style: {"height":"45px","clear":"both","width":"100% !important","padding-top":"10px","padding-bottom":"5px","border-bottom":"1px solid #efefef"}
                        }, [
                          _createElementVNode("div", _hoisted_20, _toDisplayString(p.Spec.Name) + "  ", 1),
                          _createElementVNode("div", _hoisted_21, _toDisplayString(p.Quantity) + "  ", 1)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_22, " 暂无数据 "))
              ]),
              _: 2
            }, 1032, ["label"]))
          : _createCommentVNode("", true),
        (item.Prop == 'PackageSpecs' && _ctx.type == '20')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 7,
              label: item.Label
            }, {
              label: _withCtx(() => [
                _hoisted_23
              ]),
              default: _withCtx(() => [
                _hoisted_24,
                (_ctx.detail.Data.PackageSpecs !=null &&_ctx.detail.Data.PackageSpecs !=undefined &&_ctx.detail.Data.PackageSpecs.length>0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.Data.PackageSpecs, (p, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          style: {"height":"40px","line-height":"40px","clear":"both","width":"100% !important","border-bottom":"1px solid #efefef"}
                        }, [
                          _createElementVNode("div", _hoisted_26, _toDisplayString(p.Spec.Product.NameZh) + " / " + _toDisplayString(p.Spec.Product.NameEn) + "  ", 1),
                          _createElementVNode("div", _hoisted_27, _toDisplayString(p.Spec.Name) + "  ", 1),
                          _createElementVNode("div", _hoisted_28, _toDisplayString(p.Quantity) + "  ", 1),
                          _createElementVNode("div", _hoisted_29, _toDisplayString(p.Spec.Product.ChargeUnithZh) + "/" + _toDisplayString(p.Spec.Product.ChargeUnithEn) + "  ", 1)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_30, " 暂无数据 "))
              ]),
              _: 2
            }, 1032, ["label"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])),
    (_ctx.imageForm != undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: _ctx.imageForm.Visiable,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.imageForm.Visiable) = $event)),
          "show-close": false,
          style: {"width":"50%"},
          top: "30px",
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _hoisted_31,
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_component_el_carousel, {
                interval: 5000,
                arrow: "hover"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageForm.Rows, (p, index) => {
                    return (_openBlock(), _createBlock(_component_el_carousel_item, { key: index }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("a", {
                            href: p.Url,
                            target: "_blank"
                          }, [
                            _createElementVNode("img", {
                              style: {"height":"85%"},
                              src: p.Url
                            }, null, 8, _hoisted_36)
                          ], 8, _hoisted_35),
                          _createElementVNode("div", _hoisted_37, _toDisplayString(p.Name), 1)
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _hoisted_38,
            _createElementVNode("div", _hoisted_39, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.bottomButtonsImage,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bottomButtonsImage) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickImage
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_miezz_button_bar, {
      modelValue: _ctx.bottomButtons,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.bottomButtons) = $event)),
      onHandleClick: _ctx.handleClick
    }, null, 8, ["modelValue", "onHandleClick"])
  ], 64))
}